import React, { useState } from 'react';
import { FaShareAlt } from 'react-icons/fa';
import ModalVideo from 'react-modal-video';
import { Link } from 'react-router-dom';

const ShowTimeDetails = ({ movie_detail, item }) => {
  const [isOpen, setOpen] = useState();
  const [detailsModal, setDetailsModal] = useState(false);
  const { title, genre, video, actor, release, language } = movie_detail;
  // console.log(title);
  const modalHandaler = () => {
    setDetailsModal(true);
  };
  console.log(detailsModal);
  return (
    <>
      <div className='lg:col-span-2  text-white px-5 py-10'>
        <ul>
          <h1 style={{ float: 'left', display: 'inline-block' }}>{title}</h1>
          <br /> <br />
          <li style={{ textAlign: 'left', lineHeight: '40px' }}>
            <span
              style={{
                display: 'inline-block',
                float: 'left',
                width: '85px',
                textAlign: 'left',
              }}
            >
              Category
              <label style={{ float: 'right' }}>:</label>
            </span>
            <a
              href='#'
              style={{ marginLeft: '11px' }}
            >
              2D
            </a>
          </li>
          <li style={{ textAlign: 'left', lineHeight: '40px' }}>
            <span
              style={{
                display: 'inline-block',
                float: 'left',
                width: '85px',
                textAlign: 'left',
              }}
            >
              Actor
              <label style={{ float: 'right' }}>:</label>
            </span>
            <a
              href='#'
              style={{ marginLeft: '11px' }}
            >
              {actor}
            </a>
          </li>
          <li style={{ textAlign: 'left', lineHeight: '40px' }}>
            <span
              style={{
                display: 'inline-block',
                float: 'left',
                width: '85px',
                textAlign: 'left',
              }}
            >
              Genre
              <label style={{ float: 'right' }}>:</label>
            </span>
            <a
              href='#'
              style={{ marginLeft: '11px' }}
            >
              {genre}
            </a>
          </li>
          <li style={{ textAlign: 'left', lineHeight: '40px' }}>
            <span
              style={{
                display: 'inline-block',
                float: 'left',
                width: '85px',
                textAlign: 'left',
              }}
            >
              Release
              <label style={{ float: 'right' }}>:</label>
            </span>
            <a
              href='#'
              style={{ marginLeft: '11px' }}
            >
              {release}
            </a>
          </li>
          <li style={{ textAlign: 'left', lineHeight: '40px' }}>
            <span
              style={{
                display: 'inline-block',
                float: 'left',
                width: '85px',
                textAlign: 'left',
              }}
            >
              Language
              <label style={{ float: 'right' }}>:</label>
            </span>
            <a
              href='#'
              style={{ marginLeft: '11px' }}
            >
              {language}
            </a>
          </li>
          <li className='mb-5 items-center flex'>
            <span
              style={{
                display: 'inline-block',
                float: 'left',
                width: '85px',
                textAlign: 'left',
              }}
            >
              Share
              <label style={{ float: 'right' }}>:</label>
            </span>
            <a
              href='#'
              style={{ float: 'left ', marginLeft: '11px' }}
            >
              <FaShareAlt />
            </a>
          </li>
        </ul>
        <br />

        <div className='flex justify-start gap-5 items-center'>
          <Link
            to={``}
            onClick={() => modalHandaler()}
            className='customBtn2 text-xs py-1'
          >
            Details
          </Link>
          <button
            className='customBtn1 text-xs py-1 hover:bg-btnColor hover:border-btnColor'
            onClick={() => setOpen(true)}
          >
            Watch Trailer
          </button>
        </div>

        <ModalVideo
          channel='youtube'
          isOpen={isOpen}
          onClose={() => setOpen(false)}
        >
          <iframe
            width='560'
            height='315'
            src='https://www.youtube.com/watch?v=tOiVy-Jmil8&list=RDp-cPhd1Frpc&index=4&ab_channel=RAMamunMusic'
            title='YouTube video player'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
            allowFullScreen
          ></iframe>
        </ModalVideo>
        {/* {detailsModal && <MovieDetailsModal />} */}
      </div>
    </>
  );
};

export default ShowTimeDetails;
